import { authorizedAxios } from "../../../Actions/AxiosActions";
import { IServiceResult } from "../../../Models/IServiceResult";

export async function getCountryWKT(countryAbbrv: string): Promise<IServiceResult<string>> {
    return await authorizedAxios<IServiceResult<string>>("GET", `Common/GetCountryWKT?countryAbbrv=${countryAbbrv}`, null);
}

export async function getRedirectLink(appName: string): Promise<IServiceResult<string>> {
    return await authorizedAxios<IServiceResult<string>>("GET", `/Redirect/OtherProducts?product=${appName}`);
}